<script>
    import Footer from '../landing_page/footer.svelte';
    import FaqSection from './faq_section.svelte';
    import ForSection from './for_section.svelte';
    import HeaderProgramSection from './header_program_section.svelte';
    import FaqMbl from './mobile_reuse-section/faq_mbl.svelte';
    import {
        corporateAccelerate,
        corporativeAccelerateForSection,
        FaqCorporateAccelerate,
    } from './program_data.js';
    const {title} = rpcjs.props;
    title.set('Corporative | Accelerate | Program');
    const processText = [
        {
            text: 'We start with defining your challenge and scout companies from our portfolio and pipeline '+
            ' to find companies suitable to meet those demands.',
        },
        {
            text: 'After joint due diligence, we narrow down a wide range of high-quality startups to a cohort of '+
            ' 10-12 teams capable of adding immediate value to your organization.',
        },
        {
            text: 'The teams selected are provided with capital pre-defined by you. Then we get to work '+
            ' accelerating the growth of those teams with bespoke mentorship and cohort-based learning modules '+
            ' based on the stage of the companies and their individual needs.',
        },
        {
            text: 'Finally, we promote their success and showcase their '+
            ' journey to a room full of investors or your stakeholders on demo day.',
        },
    ];
    const partnerMbl = [
        {
            image: '/images/corporative_accelerate/UNDP_logo.png',
            width: '6.666vw',
            heading: 'UNDP',
            text: '41 Companies, 27 Countries and experts including FDA, John Hopkins, Siemens and GE Healthcare ',
        },
        {
            image: '/images/draper_logo.svg',
            width: '11.238vw',
            heading: 'Draper University',
            text: 'Draper University delivered a pre-acceleration program with the understanding that In '+
            ' light of the ongoing COVID-19 pandemic, and as part of the Global Centre’s work on sustainable '+
            ' finance, UNDP is working to establish an Impact Venture Accelerating and Scaling Initiative which will '+
            ' include a Future of Healthcare Impact Venture Accelerator (IVA) and Venture Capital Fund (VCF).',
        },

        {
            image: '/images/corporative_accelerate/jet_blue.png',
            width: '13.056vw',
            heading: 'Jet Blue',
            text: 'Draper University partnered with JetBlue Technology Ventures and Cockpit Innovation - the venture '+
            ' arms of global airlines JetBlue and El Al, respectively - '+
            ' to custom design and deliver a Silicon Valley immersion '+
            ' and training program for their joint travel-tech-accelerator’s CEO’s.',
        },
    ];
    const benefitsMbl = [
        {
            back_color: '#36A1BF',
            image: '/images/corporative_accelerate/corpo_accel_why_fund_program_icons/funnel.svg',
            top: '-32.5vw',
            heading: 'Innovation Funnel',
            paragraph:
                'Build a pipeline of innovation that your company can immediately benefit from and together '+
                ' we can fast track the success of your investment by educating and surrounding the teams in your '+
                ' program with best-in-class mentorship, access to new market opportunities, and pathways to additional '+
                ' venture capital.',
        },
        {
            back_color: '#3C74C0',
            image: '/images/corporative_accelerate/corpo_accel_why_fund_program_icons/expert.svg',
            top: '-17.5vw',
            heading: 'Expert Guidance',
            paragraph:
                'We can help you every step of the way from identifying the right '+
                ' challenges to tackle to due diligence on potential investments.',
        },
        {
            back_color: '#16519A',
            image: '/images/corporative_accelerate/corpo_accel_why_fund_program_icons/globel.svg',
            top: '-20.5vw',
            heading: 'Global Network',
            paragraph:
                'Our network of global entrepreneurs, investors, and facilitators are at your disposal. '+
                ' Lean on us to source startups, promote your programs and demo days.',
        },
        {
            back_color: '#15248E',
            image: '/images/corporative_accelerate/corpo_accel_why_fund_program_icons/growth.svg',
            top: '-25.5vw',
            heading: 'Growth Investment',
            paragraph:
                'Invest in the next generation of technologies to keep winning in their respective '+
                ' industries. We provide insights on upcoming technology, its impact, and '+
                ' future-forward thinking to innovate with a 10X mentality. ',
        },
    ];
// <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
// <!-- End Google Tag Manager -->
</script>

<section>
    <HeaderProgramSection
        data={corporateAccelerate}
        lineHeight="12.299vw"
        marginTop="1.5vw"
        lineHeightMbl="11.111vw"
        TopMbl="107.5vw"
        colors = "white"
        headingTop="-11.1vw"
        headingLeft="0.3vw"
        boxTop="38.616vw"
        hrWidth="55.929vw"
        widthDescription="44.516vw"
        hrTop="-1vw"
        subheadingMbl="81.334vw"
        letterSpace="0.04vw"
        discTop="37vw"
        
    />
    <div class="desktop">
        <div style="display: flex;align-items:center; margin-left:5.556vw;margin-top: 12.037vw;">
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5.820vw; opacity:0.3;margin-top: 0.6vw;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                Partner Highlights
            </h1>
        </div>
        <div style="position: relative; margin-top: -4.3vw;">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
        </div>
        <div class="partner-highlights">
            <div style="display: flex;">
                <div class="partner-logo" style="width: 7.112vw;margin-top:0.8vw;">
                    <img
                        src="/images/draper_logo.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-left: 3.073vw;">
                    <p class="partner-heading">Draper University</p>
                    <p class="partner-text">
                        Draper University delivered a pre-acceleration program
                        with the understanding that In light of the ongoing
                        COVID-19 pandemic, and as part of the Global Centre’s
                        work on sustainable finance, UNDP is working to
                        establish an Impact Venture Accelerating and Scaling
                        Initiative which will include a Future of Healthcare
                        Impact Venture Accelerator (IVA) and Venture Capital
                        Fund (VCF).
                    </p>
                </div>
            </div>
            <div style="display: flex;">
                <div class="partner-logo" style="width: 5.159vw;">
                    <img
                        src="/images/corporative_accelerate/UNDP_logo.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-left: 2.778vw;">
                    <p class="partner-heading">UNDP</p>
                    <p class="partner-text">
                        41 Companies, 27 Countries and experts including FDA,
                        John Hopkins, Siemens and GE Healthcare
                    </p>
                </div>
            </div>
        </div>

        <div class="partner-highlights" >
            <div style="display: flex;">
                <div
                    class="partner-logo"
                    style=" width:7.341vw;"
                >
                    <img
                        src="/images/corporative_accelerate/jet_blue.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-left: 3.2vw;">
                    <p class="partner-heading"style="margin-top: -0.4vw;">Jet Blue</p>
                    <p class="partner-text" style="padding-top: 0.4vw;" >
                        Draper University partnered with JetBlue Technology
                        Ventures and Cockpit Innovation - the venture arms of
                        global airlines JetBlue and El Al, respectively - to
                        custom design and deliver a Silicon Valley immersion and
                        training program for their joint
                        travel-tech-accelerator’s CEO’s.
                    </p>
                </div>
            </div>
        </div>
        <div>
            <ForSection data={corporativeAccelerateForSection} 
            topbottomMargin= "0.992vw 0vw 1.72vw 0vw"
         />
        </div>
        <div
            style="display: flex;align-items:center; margin-left:4vw; margin-top:20.349vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;margin-top: 0.65vw;"
            >
                03
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                Why Fund This Program
            </h1>
        </div>
        <div style="position: relative; height: 55vw;">
            <div class="inner-circle" />
            <div class="funnel-div">
                <div style="display: flex; justify-content: center;">
                    <div class="fund-icon" style="width:2.646vw;">
                        <img
                            src="/images/corporative_accelerate/corpo_accel_why_fund_program_icons/funnel.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            class="fund-heading"
                            style="padding: 2vw 1vw 1vw 1vw;"
                        >
                            Innovation Funnel
                        </p>
                    </div>
                </div>

                <p class="fund-text" style="width: 27.381vw; margin:auto;">
                    Build a pipeline of innovation that your company can
                    immediately benefit from and together we can fast track the
                    success of your investment by educating and surrounding the
                    teams in your program with best-in-class mentorship, access
                    to new market opportunities, and pathways to additional
                    venture capital.
                </p>
            </div>
            <div class="expert-div">
                <div
                    style="display: flex; justify-content: center; margin-top: 2vw;"
                >
                    <div  style="width: 1.857vw;margin-top:2.2vw;">
                        <img
                            src="/images/corporative_accelerate/corpo_accel_why_fund_program_icons/expert.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            class="fund-heading"
                            style="padding: 3vw 1vw 1vw 1vw;"
                        >
                            Expert Guidance
                        </p>
                    </div>
                </div>

                <p class="fund-text" style="width: 23.381vw; margin:auto;">
                    We can help you every step of the way from identifying the
                    right challenges to tackle to due diligence on potential
                    investments.
                </p>
            </div>
            <div class="globel-div">
                <div
                    style="display: flex; justify-content: center;margin-top: 2vw;"
                >
                    <div  style="width: 3.042vw;margin-top:0.8vw">
                        <img
                            src="/images/corporative_accelerate/corpo_accel_why_fund_program_icons/globel.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            class="fund-heading"
                            style="padding: 2vw 1vw 1vw 1vw;"
                        >
                            Global Network
                        </p>
                    </div>
                </div>

                <p class="fund-text" style="width: 27.381vw; margin:auto;">
                    Our network of global entrepreneurs, investors, and
                    facilitators are at your disposal. Lean on us to source
                    startups, promote your programs and demo days.
                </p>
            </div>
            <div class="growth-div">
                <div
                    style="display: flex; justify-content: center; margin-top: 2vw;"
                >
                    <div class="fund-icon" style="width: 3.042vw;">
                        <img
                            src="/images/corporative_accelerate/corpo_accel_why_fund_program_icons/growth.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            class="fund-heading"
                            style="padding: 2vw 1vw 1vw 1vw;"
                        >
                            Growth Investment
                        </p>
                    </div>
                </div>

                <p class="fund-text" style="width: 27.381vw; margin:auto;">
                    Invest in the next generation of technologies to keep
                    winning in their respective industries. We provide insights
                    on upcoming technology, its impact, and future-forward
                    thinking to innovate with a 10X mentality.
                </p>
            </div>
        </div>
        <div
            style="position: relative; display: flex;align-items:center; margin-left:4vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:3.836vw;margin-top: 2vw;opacity:0.3;"
            >
                04
            </h1>
            <div style="margin-top:7vw;">
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                >
                    Application or Custom Design Process
                </h1>
                <p
                    style="font-size: 1.058vw; width: 46.362vw; color: #00204B; margin-top:1.587vw;line-height: 1.280vw;"
                >
                    Each program is custom designed based on the focus and
                    growth objectives of our partners. We take a case-based
                    approach featuring use cases from finance, healthcare,
                    supply chain management, and consumer products.
                </p>
            </div>
        </div>
        <div class="process-div">
            <h4
                style="font-size:1.323vw; font-weight:600; color:#00204B;padding: 2vw 3vw;"
            >
                Process
            </h4>
            <ul class="points">
                {#each processText as data}
                    <li style="padding-bottom:1.280vw;">
                        <p style="width: 57.5vw;padding-left: 2.116vw;font-size: 1.058vw;line-height:1.280vw;">
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:4vw; margin-top:10.474vw;margin-bottom:3.836vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;"
            >
                05
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;"
            >
                FAQs
            </h1>
        </div>
        <FaqSection detail={FaqCorporateAccelerate} />
      
    </div>
    <div class="mobile">
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 15vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Partner Highlights
            </h1>
        </div>
        <div>
            {#each partnerMbl as data}
                <div style="margin: 15vw 0vw;">
                    <div class="img-logo" style="width:{data.width}; margin:auto;">
                        <img src={data.image} alt="" width="100%" />
                    </div>
                    <div
                        class="head"
                        style="font-size: 5vw; font-weight:500;    text-align: center; margin-top: 6vw;margin-bottom: 2.776vw;"
                    >
                        <p>{data.heading}</p>
                    </div>
                    <div
                        style="font-size:3.056vw ; line-height:3.697vw ; width:80vw;margin:auto; color:#00204B;text-align: center;color:#00204B;"
                    >
                        <p>{data.text}</p>
                    </div>
                </div>
            {/each}
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 15vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                02
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Benefits of the Program
            </h1>
        </div>
        <div style="margin-top: 4.166vw;">
            {#each benefitsMbl as benefits}
                <div
                    class="benefits-div"
                    style="background-color:{benefits.back_color};"
                >
                    <div class="benefits_img" style="margin-top: {benefits.top};">
                        <img src={benefits.image} alt="" width="100%" />
                    </div>
                    <div style="width:56.667vw;margin-left:6vw;">
                        <p
                            class="benefits_heading"
                            style="padding-bottom: 2vw;"
                        >
                            {benefits.heading}
                        </p>
                        <p class="benefits_text" style=" margin:auto;">
                            {benefits.paragraph}
                        </p>
                    </div>
                </div>
            {/each}
        </div>
        <div style="width: 92.815vw;">
            <div>
                <h1
                    style="color: rgba(124, 193, 255, 0.2);font-size:16.66vw;     line-height: 18.056vw;
                    font-weight: bold;margin-left: 13.778vw;margin-top:20.554vw;"
                >
                    Become a Hero
                </h1>
            </div>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:1vw; margin-top: -10.3vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-left:5.556vw; opacity:0.3; margin-top: -24vw;"
            >
                03
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top: 8vw; margin-left:5.383vw;"
                >
                    Application or Custom <br /> Design Process
                </h1>
                <div style="width:70vw; margin:2vw 0vw 0vw 5.383vw">
                    <p style="font-size:3.056vw; text-align: justify;color:#00204B;
                    line-height: 4.166vw;padding-top:2.481vw;">
                        Each program is custom designed based on the focus and
                        growth objectives of our partners. We take a case-based
                        approach featuring use cases from finance, healthcare,
                        supply chain management, and consumer products.
                    </p>
                </div>
            </div>
        </div>
        <div class="process-div-mbl">
            <h4
                style="font-size:5.556vw; font-weight:600; color:#00204B;padding: 4.5vw 27vw 2.5vw 27vw;"
            >
                Process
            </h4>
            <ul class="process_mbl">
                {#each processText as data}
                    <li style="">
                        <p
                            style="width: 60vw;padding-left: 1vw;font-size: 3.056vw;line-height: 3.697vw;margin-top:4vw;"
                        >
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 15vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                04
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600;text-align: center;"
            >
                FAQs
            </h1>
        </div>
        <div style="margin-bottom: 15vw;">
            <FaqMbl detailMbl={FaqCorporateAccelerate} />
        </div>
    </div>
    <div style="margin-top: 8.069vw;">
        <Footer />
    </div>
</section>

<style>
    section {
        font-family: "inter";
    }
    *{
        padding: 0;
        margin: 0;
    }
    .circle {
        height: 18.204vw;
        width: 18.204vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -11vw;
        background-color: rgba(60, 136, 195, 0.33);
        justify-content: center;
        top: -2.8vw;
}
    .circle:nth-child(2) {
        top: 12vw;
    }
    .circle:nth-child(3) {
        top: 26.5vw;
    }
    .partner-highlights {
        display: flex;
        margin-left: 12.698vw;
        margin-top: 8vw;
        width: 77.85vw;
        justify-content: space-between;
    }
    .partner-heading {
        font-size: 2.116vw;
        font-weight: 500;
        color: #00204b;
    }
    .partner-text {
        width: 25.4vw;
        font-size: 1.058vw;
        padding-top: 0.85vw;
        color: #00204B;
        line-height: 1.280vw;
    }
    .inner-circle {
        width: 11.706vw;
        height: 11.706vw;
        top: 22.421vw;
        left: 44.114vw;
        background-color: #00347a;
        border-radius: 50%;
        position: absolute;
    }
    .funnel-div {
        width: 34.127vw;
        height: 19.577vw;
        background: #36a1bf;
        border-radius: 1.323vw;
        top: 4.563vw;
        left: 17.526vw;
        position: absolute;
    }
    .fund-icon {
        margin-top: 1.5vw;
    }
    .fund-heading {
        font-size: 1.455vw;
        font-weight: 600;
        text-align: center;
        color: white;
    }
    .fund-text {
        font-size: 1.19vw;
        font-weight: 300;
        text-align: center;
        color: white;
        line-height: 1.653vw;
    }
    .expert-div {
        width: 34.127vw;
        height: 19.577vw;
        background: #3c74c0;
        border-radius: 1.323vw;
        top: 11.772vw;
        left: 50.926vw;
        position: absolute;
    }
    .globel-div {
        background: #16519a;
        width: 34.127vw;
        height: 19.577vw;
        border-radius: 1.323vw;
        top: 25.331vw;
        left: 14.881vw;
        position: absolute;
    }
    .growth-div {
        background: #15248e;
        width: 34.127vw;
        height: 19.577vw;
        border-radius: 1.323vw;
        top: 32.54vw;
        left: 46.495vw;
        position: absolute;
    }
    .process-div {
        width: 67.13vw;
        box-shadow: 0px -1.124vw 1.323vw rgba(60, 116, 192, 0.2);
        border-radius: 2vw;
        margin: 2.844vw 0vw 2.844vw 23.347vw;
    }
    ul {
        padding: 0;
        margin: 0;
        margin-left: 9.7vw;
        padding-bottom: 2.355vw;
    }
    ul li::marker {
        color: #7cc1ff;
        font-size: 1.058vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        li::marker {
            font-size: 3.556vw !important;
        }
        .benefits-div {
            width: 86.111vw;
            height: 52.778vw;
            border-radius: 5.556vw;
            box-shadow: 0px -4.444vw 20.556vw rgba(124, 193, 255, 0.2);
            margin: auto;
            margin-top: 2vw;
            display: flex;
            align-items: center;
        }
        .benefits_img {
            width: 6vw;
            margin-left: 7vw;
        }
        .benefits_heading {
            font-size: 4.444vw;
            font-weight: 600;
            color: white;
        }
        .benefits_text {
            font-size: 2.778vw;
            font-weight: 300;
            color: white;
        }
    }
    .process-div-mbl {
        width: 76.111vw;
        height: 113vw;
        background-color: white;
        border-radius: 7vw 7vw 0vw 0vw;
        box-shadow: 0px -9px 20px rgba(60, 116, 192, 0.2);
        margin: auto;
        margin-top: 10vw;
    }
    .process_mbl li::marker {
        color: #7cc1ff;
        font-size: 4.19vw;
    }
</style>
